import Image from '../../form-elements/Image';
import { StoreConfigWidgetProps } from '../../types/store-config-widget';

function ImageWidget(props: StoreConfigWidgetProps) {
  return (
    <Image
      placeholder={props.placeholder}
      value={props.value}
      onChange={props.onChange}
      onFocus={props.onFocus}
      id={props.id}
    />
  );
}

export default ImageWidget;
